<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
    <ng-template pTemplate>
      <p-splitter [panelSizes]="[50, 50]" class="w-full pb-7" styleClass="h-full">
        <ng-template pTemplate>
          <div class="flex-col w-full h-full">
            <div class="flex pb-2">
              <div class="pt-2 pr-3 pl-2">
                <h6>Product Tags</h6>
              </div>
            </div>
            <div class="w-full h-full pr-4">
              <prox-ag-grid [gridOptions]="ppttGridOptions" [rowData]="pptts" [hasFooter]="true"></prox-ag-grid>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div class="flex-col pr-1 w-full h-full">
            <div class="flex pb-2 gap-2">
              <div class="pt-1 pl-4 mt-2">
                <h6>Menu Categories</h6>
              </div>
              <p-button [disabled]="parent.isReadOnly()" (click)="onPpctAdd()" label="Add Menu Category"
                icon="pi pi-plus" size="small"></p-button>
              <p-button (click)="onTestMenu()" label="Menu Tester" icon="fa-duotone fa-solid fa-square-list"
                size="small"></p-button>
            </div>
            <div class="ml-4 w-full h-full">
              <prox-ag-grid [gridOptions]="ppctGridOptions" [rowData]="ppcts"></prox-ag-grid>
            </div>

          </div>
        </ng-template>
      </p-splitter>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex grow w-full">

        <div class="flex flex-col h-full w-full">
          <div class="flex mt-2">
            <h6>Product Types in this Program with Tag: {{this.selectedPptt?.name}} </h6>
          </div>
          <div class="flex-col w-full h-full pb-2">
            <prox-ag-grid [gridOptions]="tmapGridOptions" [rowData]="tmaps"></prox-ag-grid>
          </div>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</div>